module.exports = __webpack_public_path__ + "static/waranont-joe-T7qyLNPwgKA-unsplash-798b2fb60b7cbee2c459b921d30019e8.jpg";